import { Component } from 'react';
import Icon from '../../../components/Icon';
import canUseDOM from '../../../utilities/canUseDOM';
import popupAlert from '../../../utilities/popup-alert';
import { getIsFavourite } from '../productPageApi';
import {
  PILannounce,
  PILregister,
  PILunregister
} from '../../../utilities/productsILoveCoordinator';

export enum PositionLeftRight {
  Left = 'left',
  Right = 'right'
}

interface ProductsILoveProps {
  catalogueRef?: string | null;
  isLoggedIn?: boolean;
  isEnabled: boolean;
  positionLeftRight?: PositionLeftRight;
  top?: string;
  right?: string;
}

interface ProductsILoveState {
  showLoginMessage: boolean;
  isFavourite: boolean | null;
  currentPath: string;
  onHover: boolean;
}

class ProductsILove extends Component<ProductsILoveProps, ProductsILoveState> {
  constructor(props: ProductsILoveProps) {
    super(props);

    const { isLoggedIn } = this.props;

    this.state = {
      showLoginMessage: isLoggedIn === false,
      currentPath: canUseDOM() ? window.location.pathname : '',
      isFavourite: null,
      onHover: false
    };
  }

  catalogueRef? = this.props.catalogueRef;
  apiBasePath = '/umbraco/surface/productssurface/';
  path = `${this.apiBasePath}UpdateFavouriteProducts`;
  headers: RequestInit = {
    credentials: 'same-origin',
    headers: {
      'content-type': 'application/json',
      accept: 'application/json'
    }
  };

  componentDidMount() {
    this.getIsFavouriteData();
    if (this.catalogueRef) {
      PILregister(this.catalogueRef, (value: boolean) => {
        this.setState({
          isFavourite: value
        });
      });
    }
  }
  componentWillUnmount(): void {
    //remove from products i love registration
    PILunregister();
  }

  getIsFavouriteData = () => {
    getIsFavourite(this.props.catalogueRef)
      .then((data: any) => {
        this.setState({
          isFavourite: data
        });
      })
      .catch((err: any) => console.error(err));
  };

  handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
    const button = event.target as HTMLDivElement;
    if (this.catalogueRef && this.catalogueRef !== null) {
      if (this.state.isFavourite) {
        this.deleteFavourite(button, this.catalogueRef);
      } else if (!this.state.isFavourite) {
        this.addFavourite(button, this.catalogueRef);
      }
    }
  };

  addFavourite(button: HTMLDivElement, catalogueRef: string | null) {
    return fetch(this.path, {
      method: 'POST',
      ...this.headers,
      body: JSON.stringify({
        catalogueRefs: [catalogueRef],
        isRemove: false
      })
    })
      .then((response: any) => {
        if (response.ok && response.warning) {
          popupAlert.showWarning(response.message);
        } else if (!response.ok) {
          popupAlert.showNegative(
            'There was a problem completing this request, please try again.'
          );
        } else {
          this.setState({
            isFavourite: true
          });
          if (this.catalogueRef) {
            PILannounce(this.catalogueRef, true);
          }
          popupAlert.showPositive('Item has been added to Products I Love');
        }
      })
      .catch((error: any) => {
        console.log('Error:', error);
      });
  }

  deleteFavourite(button: HTMLDivElement, catalogueRef: string) {
    return fetch(this.path, {
      method: 'POST',
      ...this.headers,
      body: JSON.stringify({
        catalogueRefs: [catalogueRef],
        isRemove: true
      })
    })
      .then((response: any) => {
        if (response.ok && response.warning) {
          popupAlert.showWarning(response.message);
        } else if (!response.ok) {
          popupAlert.showNegative(
            'There was a problem completing this request, please try again.'
          );
        } else {
          this.setState({
            isFavourite: false
          });
          if (this.catalogueRef) {
            PILannounce(this.catalogueRef, false);
          }
          popupAlert.showPositive('Item has been removed from Products I Love');
        }
      })
      .catch((error: any) => {
        console.log('Error:', error);
      });
  }

  render() {
    const { isFavourite } = this.state;
    const positionLeftRight =
      this.props.positionLeftRight ?? PositionLeftRight.Right;
    const top = this.props.top ?? '5px';
    const leftRight = this.props.right ?? '5px';

    return (
      <>
        {this.props.isEnabled && this.catalogueRef != '' && (
          <div
            style={{
              position: 'absolute',
              [positionLeftRight]: leftRight,
              top: top,
              height: '14%',
              width: '14%',
              minHeight: '30px',
              minWidth: '30px',
              maxHeight: '50px',
              maxWidth: '50px',
              fontSize: '28px'
            }}
          >
            <div
              style={{ position: 'relative', height: '100%' }}
              className="icon--productsilove"
              onClick={(e) => {
                this.handleClick(e);
                e.preventDefault();
                e.stopPropagation();
              }}
              onMouseOver={() => {
                this.setState({
                  onHover: true
                });
              }}
              onMouseOut={() => {
                this.setState({
                  onHover: false
                });
              }}
            >
              {isFavourite || this.state.onHover ? (
                <Icon
                  iconName="heart-on-product-hover"
                  modifierCss={
                    isFavourite
                      ? 'icon--productsilove-mod--clicked'
                      : 'icon--productsilove-mod'
                  }
                />
              ) : (
                <Icon
                  iconName="heart-on-product"
                  modifierCss={
                    isFavourite
                      ? 'icon--productsilove-mod--clicked'
                      : 'icon--productsilove-mod'
                  }
                />
              )}
            </div>
          </div>
        )}
      </>
    );
  }
}

export default ProductsILove;
